import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/logo-tracker.svg'


const _hoisted_1 = { class: "page-auth" }
const _hoisted_2 = { class: "auth-container" }
const _hoisted_3 = { class: "login-logo" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "auth-title" }
const _hoisted_6 = { class: "login-input" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "login-input" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = {
  key: 0,
  class: "login-error"
}
const _hoisted_11 = {
  type: "submit",
  class: "button auth-button"
}
const _hoisted_12 = { class: "forgot-bar" }
const _hoisted_13 = {
  href: "https://www.tracker.com/",
  class: "auth-powered",
  target: "_blank"
}
const _hoisted_14 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavLink = _resolveComponent("NavLink")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: _ctx.$t('pages.auth.login.logo_alt')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('pages.auth.login.title')), 1),
      _createElementVNode("form", {
        class: "login-form",
        onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
      }, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
            class: _normalizeClass({ error: _ctx.error }),
            type: "text",
            placeholder: _ctx.$t('pages.auth.login.placeholder.username')
          }, null, 10, _hoisted_7), [
            [_vModelText, _ctx.username]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            class: _normalizeClass({ error: _ctx.error }),
            type: "password",
            placeholder: _ctx.$t('pages.auth.login.placeholder.password')
          }, null, 10, _hoisted_9), [
            [_vModelText, _ctx.password]
          ])
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('pages.auth.login.error')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.$t('pages.auth.login.button')), 1)
      ], 32),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, {
          to: "/forgot-password",
          custom: ""
        }, {
          default: _withCtx(({ href, navigate, isActive }) => [
            _createVNode(_component_NavLink, {
              active: isActive,
              href: href,
              onClick: navigate
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('pages.auth.login.forgot_button')), 1)
              ]),
              _: 2
            }, 1032, ["active", "href", "onClick"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("a", _hoisted_13, [
      _createTextVNode(_toDisplayString(_ctx.$t('pages.auth.login.powered_by')) + " ", 1),
      _createElementVNode("img", {
        src: _imports_0,
        alt: _ctx.$t('pages.auth.login.powered_by_alt')
      }, null, 8, _hoisted_14)
    ])
  ]))
}